import styles from "./AccountingGroupSelector.module.scss"

type Props = {
	accountingGroups: { id: string; name: string }[]
	selectedGroupId: string | null
	onSelectGroup: (groupId: string) => void
	onClickCreate: () => void
	onClickEditMapping: () => void
	isSouhlAdmin: boolean
}

const AccountingGroupSelector = ({
	accountingGroups,
	selectedGroupId,
	onSelectGroup,
	onClickCreate,
	onClickEditMapping,
	isSouhlAdmin,
}: Props) => {
	return (
		<div className={styles.selector}>
			<div className={styles.selector_row}>
				<select
					className={styles.group_select}
					value={selectedGroupId ?? ""}
					onChange={(e) => onSelectGroup(e.target.value)}
				>
					{accountingGroups.length === 0 && (
						<option value="" disabled>
							経理グループがありません
						</option>
					)}
					{accountingGroups.map((group) => (
						<option key={group.id} value={group.id}>
							{group.name}
						</option>
					))}
				</select>
				<button
					type="button"
					className={styles.add_button}
					onClick={onClickCreate}
					title="経理グループを作成"
				>
					+
				</button>
				{isSouhlAdmin && (
					<button
						type="button"
						className={styles.mapping_button}
						onClick={onClickEditMapping}
					>
						経理グループ・店舗 紐付け編集
					</button>
				)}
			</div>
		</div>
	)
}

export default AccountingGroupSelector
